import { createContext, FC, ReactNode, useContext, useState } from "react";

type AlertSeverity = "success" | "info" | "warning" | "error";

interface AlertContextProps {
  showAlert: (message: string, severity: AlertSeverity) => void;
  closeAlert: () => void;
  alert: { message: string; severity: AlertSeverity } | null;
}

const AlertContext = createContext<AlertContextProps>({} as AlertContextProps);

interface AlertProviderProps {
  children: ReactNode;
}

const AlertProvider: FC<AlertProviderProps> = ({ children }) => {
  const [alert, setAlert] = useState<{
    message: string;
    severity: AlertSeverity;
  } | null>(null);

  const showAlert = (message: string, severity: AlertSeverity) => {
    setAlert({ message, severity });
    setTimeout(() => {
      setAlert(null); // Ocultar alerta después de 5 segundos
    }, 5000);
  };

  const closeAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider
      value={{
        showAlert,
        closeAlert,
        alert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

const useCustomAlert = () => useContext(AlertContext);

export { AlertProvider, useCustomAlert };
